import clsx from "clsx"
import {forwardRef, useImperativeHandle, useRef, useState} from "react"
import FileUploadIcon from "~/icons/FileUploadIcon"
import "./FileUpload.css"

interface FileUploadProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "placeholder"> {
    id: string
    invalid?: boolean
    placeholder?: string | undefined | null
    containerProps?: React.HTMLAttributes<HTMLDivElement> | undefined
}

const FileUpload: React.FC<FileUploadProps> = forwardRef<HTMLInputElement, FileUploadProps>((props, ref) => {
    const {className, id, invalid, placeholder, onChange, containerProps, children, ...otherProps} = props
    const [label, setLabel] = useState(placeholder)
    const [loaded, setLoaded] = useState(false)
    const innerRef = useRef<HTMLInputElement | null>(null)
    useImperativeHandle(ref, () => innerRef.current!, [innerRef])

    const onInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) onChange(event)
        if (!event.currentTarget.files || event.currentTarget.files.length < 1) {
            setLabel(placeholder)
            setLoaded(false)
            return
        }
        const filename = event.currentTarget.files[0]?.name
        setLabel(filename)
        setLoaded(true)
    }

    const onLabelKeyDownHandler = (event: React.KeyboardEvent<HTMLLabelElement>) => {
        switch (event.key) {
            case "Enter":
                event.preventDefault()
                innerRef.current?.click()
                break
            case " ":
                event.preventDefault()
                innerRef.current?.click()
                break
        }
    }

    return (
        <div
            className={clsx(
                "file-upload-container-x8np",
                loaded ? "" : "gray-x8np",
                invalid ? "invalid-x8np" : "",
                className,
            )}
            {...containerProps}
        >
            <label className="label-x8np" htmlFor={id} tabIndex={0} onKeyDown={onLabelKeyDownHandler}>
                {label}
            </label>
            <input
                id={id}
                className="file-upload-x8np"
                type="file"
                ref={innerRef}
                {...otherProps}
                onChange={onInputChangeHandler}
            />
            <div className="icon-container-x8np">
                <FileUploadIcon className="icon-x8np" />
            </div>
        </div>
    )
})

export default FileUpload
